<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <b-overlay
      :show="show"
      :variant="variant"
      :opacity="opacity"
      :blur="blur"
      rounded="lg"
      spinner-variant="primary"
    >
      <div id="dashboard-analytics">
        <div class="vx-row">
          <div
            class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base"
          >
            <router-link :to="'/admin/companies'">
              <div>
                <b-card class="pt-5 vx-card">
                  <b-card-text class="text-center">
                    <b-icon
                      icon="people"
                      style="color: #7367f0"
                      class="rounded-circle"
                      font-scale="1.5"
                    ></b-icon>
                  </b-card-text>
                  <b-card-title class="text-center">
                    {{ companyCount }}
                  </b-card-title>
                  <b-card-text class="text-center">
                    {{ $t("TotalCompanies") }}
                  </b-card-text>
                </b-card>
              </div>
            </router-link>
          </div>
          <div
            class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base"
          >
            <router-link :to="'/admin/users'">
              <div>
                <b-card class="pt-5 vx-card">
                  <b-card-text class="text-center">
                    <b-icon
                      icon="person"
                      style="color: #ff9f43"
                      class="rounded-circle"
                      font-scale="1.5"
                    ></b-icon>
                  </b-card-text>
                  <b-card-title class="text-center">
                    {{ usersCount }}
                  </b-card-title>
                  <b-card-text class="text-center">
                    {{ $t("Users") }}
                  </b-card-text>
                </b-card>
              </div>
            </router-link>
          </div>
          <div
            class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base"
          >
            <!-- <router-link :to="'/admin/payments'"> -->
            <div>
              <b-card class="pt-5 vx-card">
                <b-card-text class="text-center">
                  <b-icon
                    icon="calendar2-event"
                    style="color: #ea5455"
                    class="rounded-circle"
                    font-scale="1.5"
                  ></b-icon>
                </b-card-text>
                <b-card-title class="text-center">
                  {{ appCount }}
                </b-card-title>
                <b-card-text class="text-center">
                  {{ $t("TotalAppointments") }}
                </b-card-text>
              </b-card>
            </div>
            <!-- </router-link> -->
          </div>
          <div
            class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base"
          >
            <router-link :to="'/admin/payments'">
              <div>
                <b-card class="pt-5 vx-card">
                  <b-card-text class="text-center">
                    <b-icon
                      icon="wallet2"
                      style="color: #28c76f"
                      class="rounded-circle"
                      font-scale="1.5"
                    ></b-icon>
                  </b-card-text>
                  <b-card-title class="text-center">
                    {{ totalRevenue }}
                  </b-card-title>
                  <b-card-text class="text-center">
                    {{ $t("TotalRevenue") }}
                  </b-card-text>
                </b-card>
              </div>
            </router-link>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full md:w-1/3 lg:w-1/3 xl:w-1/3 mb-base">
            <b-card class="pt-5 pb-5 vx-card">
              <b-card-title>
                {{ $t("AppointmentStatistics") }}
              </b-card-title>
              <div class="mb-20">
                <div
                  v-for="(app, index) in appSat"
                  :key="index"
                  :class="{ 'mt-4': index }"
                >
                  <div class="flex justify-between mt-4">
                    <div class="flex flex-col">
                      <span class="mb-1">{{ $t(app.label) }}</span>
                    </div>
                    <div class="flex flex-col text-right">
                      <span class="flex -mr-1">
                        <span class="mr-1"
                          ><strong>{{ app.count }}</strong></span
                        >
                      </span>
                    </div>
                  </div>
                  <vs-progress :percent="app.count"></vs-progress>
                </div>
              </div>
            </b-card>
          </div>

          <div class="vx-col w-full md:w-2/3">
            <chartjs-line-chart
              :title="appTitle"
              :data="appData"
              :options="appOptions"
              v-on:filterData="getAppFilterData"
            ></chartjs-line-chart>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <chartjs-bar-chart
              :title="revenueTitle"
              :data="revenueData"
              :options="revenueOptions"
              v-on:filterData="getRevenueFilterData"
            ></chartjs-bar-chart>
          </div>
        </div>
        <b-card>
          <h4 class="head">
            {{ $t("Payments") }}
            <feather-icon
              id="export"
              icon="DownloadCloudIcon"
              svgClasses="w-5 h-5 hover:text-danger stroke-current"
              class="ml-5"
              :title="$t('Export')"
              v-b-modal.modal-1
            />
          </h4>

          <b-modal
            id="modal-1"
            :title="$t('ExportToExcel')"
            :ok-title="$t('Export')"
            :cancel-title="$t('Cancel')"
            @ok="exportToExcel"
            @cancel="clearFields"
            @close="clearFields"
            class="export-options"
            centered
          >
            <b-form-input
              v-model="fileName"
              class="w-full"
              :placeholder="$t('FileName')"
            ></b-form-input>
            <v-select v-model="selectedFormat" :options="formats" class="my-2"
              ><template v-slot:option="option">
                <span :class="option.icon">{{ option.label }} </span>
                <feather-icon
                  v-if="selectedFormat == option.label"
                  icon="CheckIcon"
                  class="float-right"
                  svgClasses="w-5 h-5"
                />
              </template>
            </v-select>
            <div class="flex walk-card">
              <span class="mr-3">{{ $t("CellAutoWidth") }}:</span>
              <b-form-checkbox
                v-model="cellAutoWidth"
                size="lg"
                name="cell_width"
                switch
              >
              </b-form-checkbox>
            </div>
          </b-modal>

          <div class="export-table">
            <br />
            <div class="vx-row">
              <date-picker
                id="datepick"
                v-model="dateRange"
                @input="changeSplit"
                range
                class="vx-col w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2 mt-5"
                :placeholder="$t('SelectDateRange')"
              ></date-picker>
              <!--Optional scope for the input displaying the dates -->
              <div
                class="w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2 mt-5 vx-col"
              >
                <v-select
                  v-model="selected"
                  :options="options"
                  :placeholder="$t('SelectSplitBy')"
                  @input="changeSplit"
                />
              </div>
              <div
                class="w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2 mt-5 vx-col"
              >
                <v-select
                  v-model="status"
                  :options="options1"
                  :placeholder="$t('SelectStatus')"
                  @input="changeSplit"
                />
              </div>
            </div>
            <br />
            <!-- <vs-table
          :data="payments"
          pagination
          :max-items="5"
          id="example"
          :noDataText="$t('NoData')"
        >
          <template slot="thead">
            <vs-th sort-key="user" v-if="!selected">{{$t('User')}}</vs-th>
            <vs-th sort-key="company">{{$t('Company')}}</vs-th>
            <vs-th sort-key="department_name" v-if="selected != $t('Company')">{{$t('Department')}}</vs-th>
            <vs-th sort-key="staff" v-if="!selected || selected == $t('Staff')">{{$t('Staff')}}</vs-th>
            <vs-th sort-key="amount">{{$t('Amount')}}</vs-th>
            <vs-th sort-key="payment_date" v-if="!selected">{{$t('Date')}}</vs-th>
            <vs-th sort-key="payment_status" v-if="!selected">{{$t('Status')}}</vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="data[indextr].user_name" v-if="!selected">{{data[indextr].user_name}}</vs-td>
              <vs-td :data="data[indextr].company_name">{{data[indextr].company_name}}</vs-td>
              <vs-td
                :data="data[indextr].department_name"
                v-if="selected != $t('Company')"
              >{{data[indextr].department_name}}</vs-td>
              <vs-td
                :data="data[indextr].staff_name"
                v-if="!selected || selected == $t('Staff')"
              >{{data[indextr].staff_name}}</vs-td>
              <vs-td :data="data[indextr].amount">
                {{data[indextr].amount}}
                <span v-if="selected !==''">USD</span>
              </vs-td>
              <vs-td
                :data="data[indextr].payment_date"
                v-if="!selected"
              >{{data[indextr].payment_date}}</vs-td>
              <vs-td
                :data="data[indextr].payment_status"
                v-if="!selected"
              >{{ data[indextr].payment_status }}</vs-td>
            </vs-tr>
          </template>
        </vs-table> -->

            <!--  -->

            <div class="export-table mt-10">
              <b-table
                :current-page="currentPage"
                :per-page="perPage"
                :items="payments"
                :fields="fields"
                :busy="isBusy"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                responsive
                show-empty
                :filter="filter"
                :filter-included-fields="filterOn"
                :empty-text="$t('EmptyData')"
                :empty-filtered-text="$t('EmptyFilter')"
              >
                <!-- rows -->
                <template #head()="data">
                  <span>{{ $t(data.label) }}</span>
                </template>
                <template #cell(payment_status)="data">
                  {{ data.item.payment_status ? $t("Paid") : $t("NotPaid") }}
                </template>
                <template #cell()="data">
                  {{ $t(data.value) || "NA" }}
                </template>
              </b-table>

              <b-pagination
                v-if="rows > perPage"
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                aria-controls="my-table"
                class="float-right"
              ></b-pagination>
            </div>
          </div>
        </b-card>
      </div>
    </b-overlay>
  </div>
</template>
<script>
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
import ChartjsBarChart from "@/components/chart/ChartjsBarChart.vue";
import ChartjsPieChart from "@/components/chart/ChartjsPieChart.vue";
import ChartjsDoughnutChart from "@/components/chart/ChartjsDoughnutChart.vue";
import ChartjsLineChart from "@/components/chart/ChartjsLineChart.vue";
import ChangeTimeDurationDropdown from "@/components/chart/ChangeTimeDurationDropdown.vue";
import moment from "moment";
import vSelect from "vue-select";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { getTitles, getCol } from "@/utils/helper";

export default {
  data() {
    return {
      props: {
        Statistic: {
          type: String,
        },
        dateRange: {
          type: Object,
        },
      },
      appSat: "",
      height: 280,
      selectedRevenue: "Current Month",
      selectedApp: "Current Month",
      paymentData: {},
      appointmnetData: {},
      companyData: {},
      fileName: "",
      formats: ["xlsx", "csv", "txt"],
      cellAutoWidth: true,
      selectedFormat: "xlsx",
      title: [],
      values: [],
      companyCount: 0,
      usersCount: 0,
      payments: [],
      options1: [this.$t("Paid"), this.$t("NotPaid")],
      status: "",
      headerTitle: getTitles(),
      headerVal: getCol(),
      role: this.$store.getters.roles,
      options: [this.$t("Company"), this.$t("Department"), this.$t("Staff")],
      selected: "",
      activePrompt: false,
      dateRange: {},
      totalRevenue: 0,
      revenueData: {},
      revenueOptions: {
        responsive: true,
        legend: { display: false },
        scales: {
          yAxes: [
            {
              display: true,
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      },
      revenueTitle: "",
      appData: {},
      appOptions: {
        responsive: true,
        legend: { display: false },
        scales: {
          yAxes: [
            {
              display: true,
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      },
      appTitle: "",
      appCount: 0,
      perPage: 10,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      isBusy: false,

      fields: [
        {
          key: "user_name",
          label: "User",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "company_name",
          label: "Company",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "department_name",
          label: "Department",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "staff_name",
          label: "Staff",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "amount",
          label: "Amount",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "payment_date",
          label: "Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "payment_status",
          label: "Status",
          sortable: true,
          sortDirection: "desc",
        },
      ],
      show: false,
      variant: "light",
      opacity: 0.85,
      blur: "2px",
      error: "",
      success: "",
    };
  },
  watch: {
    "$i18n.locale": {
      handler: function (value) {
        this.options = [
          this.$t("Company"),
          this.$t("Department"),
          this.$t("Staff"),
        ];
        this.options1 = [this.$t("Paid"), this.$t("NotPaid")];
        this.getPieChartData();
        this.getCompanyPieChartData();
        this.getAppFilterData(this.selectedApp);
        this.getRevenueFilterData(this.selectedRevenue);
      },
    },
  },
  computed: {
    rows() {
      return this.payments.length;
    },
  },
  components: {
    StatisticsCardLine,
    vSelect,
    DatePicker,
    ChartjsBarChart,
    ChangeTimeDurationDropdown,
    ChartjsPieChart,
    ChartjsLineChart,
    ChartjsDoughnutChart,
  },
  created() {
    this.options = [
      this.$t("Company"),
      this.$t("Department"),
      this.$t("Staff"),
    ];
    this.options1 = [this.$t("Paid"), this.$t("NotPaid")];
    // Dispatched Orders
    this.getDashboardData();
    this.getPieChartData();
    this.getCompanyPieChartData();
    this.getAppFilterData("Current Month");
    this.getRevenueFilterData("Current Month");
    this.changeSplit();
  },
  methods: {
    /**
     *  exportToExcel method for export file according to format
     **/
    exportToExcel() {
      this.headerTitle = getTitles(this.selected);
      this.headerVal = getCol(this.selected);

      import("@/assets/utils/export").then((excel) => {
        const list = this.payments;
        this.headerTitle.map((title, index) => {
          this.headerTitle[index] = this.$t(title);
        });

        const data = this.formatJson(this.headerVal, list);
        excel.export_json_to_excel({
          header: this.headerTitle,
          data,
          filename: this.fileName,
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat,
        });
        this.headerTitle = getTitles();
        this.clearFields();
      });
    },
    /**
     *  @params filterVal ,jsonData
     * formatJson   method  for export file according to format
     **/
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          return v[j];
        })
      );
    },
    /**
     *
     * clearFields   method  for export selected format
     **/
    clearFields() {
      this.fileName = "";
      this.cellAutoWidth = true;
      this.selectedFormat = "xlsx";
    },

    /**
     * lang conversion
     */
    getOriginalValue(value) {
      if (value == this.$t("Company")) {
        return "Company";
      } else if (value == this.$t("Department")) {
        return "Department";
      } else if (value == this.$t("Staff")) {
        return "Staff";
      }
      return "";
    },

    /**
     * payment details based on filters
     */
    changeSplit() {
      var paymentStatus = "";
      if (this.status == this.$t("Paid")) {
        paymentStatus = 1;
      }
      if (this.status == this.$t("NotPaid")) {
        paymentStatus = 0;
      }

      if (this.selected) {
        this.selected = this.getOriginalValue(this.selected);
      }
      if (this.dateRange.length != undefined) {
        var data = {
          split_type: this.selected ? this.selected.toLowerCase() : "",
          start_date:
            this.dateRange[0] != null
              ? moment(this.dateRange[0]).format("YYYY-MM-DD")
              : "",
          end_date:
            this.dateRange[1] != null
              ? moment(this.dateRange[1]).format("YYYY-MM-DD")
              : "",
        };
      } else {
        var data = {
          split_type: this.selected ? this.selected.toLowerCase() : "",
        };
      }
      if (paymentStatus == "0" || paymentStatus == "1") {
        data.status = paymentStatus;
      }
      this.selected = this.$t(this.selected);
      this.sortData(data);
    },
    /**
     * sort data
     */
    sortData(data) {
      this.success = "";
      this.error = "";
      this.payments = [];
      this.show = true;
      this.$store
        .dispatch("SplitValue", data)
        .then((res) => {
          this.show = false;
          let payments = res.data.data;
          this.payments = payments;
        })
        .catch((error) => {
          this.$log.error(
            "File : admin/Dashboard.vue | Function : sortData() | Error :",
            error
          );
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },

    /**
     * getDashboardData   method  for superadmin dashboard data
     **/
    getDashboardData() {
      this.show = true;
      this.success = "";
      this.error = "";
      this.$store
        .dispatch("CountCompany")
        .then((res) => {
          this.show = false;
          if (res && res.data && res.data.data) {
            this.companyCount = res.data.data.company;
            this.totalRevenue = "$ " + res.data.data.revenue;
            this.usersCount = res.data.data.users;
            this.appCount = res.data.data.appointment_count;
          }
          else{
            throw new Error(`There is an error ,status -${res.status} - ${res.statusText}`);
          }
        })
        .catch((error) => {
          this.$log.error(
            "File : admin dashboard.vue | Function : getDashboardData() | Error :",
            error
          );
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },

    /**
     * get revenue bar chart filter data
     */
    getRevenueFilterData(val) {
      this.selectedRevenue = val;
      let type = val.toLowerCase().replace(/\s/g, "_");
      this.revenueTitle = "Revenue";
      var data = {
        type: type,
      };
      this.$store
        .dispatch("GetRevenueChartData", data)
        .then((res) => {
          this.show = false;
          if (res.data.data.amount.labels.length == 12) {
            res.data.data.amount.labels = this.$t("monthNames");
          }
          this.revenueData = {
            labels: Object.values(res.data.data.amount.labels),
            datasets: [
              {
                backgroundColor: "#7367F0",
                data: res.data.data.amount.values,
              },
            ],
          };
        })
        .catch((error) => {
          this.$log.error(
            "File : dashboard.vue | Function : getRevenueFilterData() | Error :",
            error
          );
          this.show = false;
          return false;
        });
    },
    /**
     * get revenue bar chart filter data
     */
    getAppFilterData(val) {
      this.show = true;
      this.selectedApp = val;
      let type = val.toLowerCase().replace(/\s/g, "_");
      this.appTitle = "Appointments";
      var data = {
        type: type,
      };
      this.$store
        .dispatch("GetAppChartData", data)

        .then((res) => {
          this.show = false;
          this.appData = {
            labels: Object.values(res.data.data.labels),
            datasets: [
              {
                data: res.data.data.values,
                borderColor: "#7367F0",
                fill: false,
              },
            ],
          };
          if (this.appData.labels.length == 12) {
            this.appData.labels = this.$t("monthNames");
          }
        })
        .catch((error) => {
          this.$log.error(
            "File : dashboard.vue | Function : getAppFilterData() | Error :",
            error
          );
          this.show = false;
          return false;
        });
    },
    /**
     * get revenue bar chart filter data
     */
    getPieChartData() {
      this.show = true;
      this.$store
        .dispatch("GetPieChartData")

        .then((res) => {
          this.show = false;
          this.appSat = res.data.data;
        })
        .catch((error) => {
          this.$log.error(
            "File : dashboard.vue | Function : getAppFilterData() | Error :",
            error
          );
          this.show = false;
          return false;
        });
    },
    /**
     * get revenue bar chart filter data
     */
    getCompanyPieChartData() {
      this.show = true;
      this.$store
        .dispatch("GetCompanyPieChartData")

        .then((res) => {
          this.show = false;
          var companyLabels = [];
          var companyValues = [];
          var companyColors = [];
          res.data.data.map((obj) => {
            companyLabels.push(obj.company_name);
            companyValues.push(obj.count);
            companyColors.push(this.getRandomColor());
          });

          this.companyData = {
            labels: Object.values(companyLabels),
            datasets: [
              {
                backgroundColor: companyColors,
                data: companyValues,
              },
            ],
          };
        })
        .catch((error) => {
          this.$log.error(
            "File : dashboard.vue | Function : getAppFilterData() | Error :",
            error
          );
          this.show = false;
          return false;
        });
    },
    // set randome colors
    getRandomColor() {
      var letters = "0123456789ABCDEF";
      var color = "#";
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
  },
};
</script>

<style lang="scss" scoped>
.splitby.w-1\/3 {
  width: 27% !important;
}
a {
  color: #626262 !important;
}
.v-select .vs__dropdown-toggle {
  height: 34px;
}
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user {
    position: relative;

    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }
    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}
#hide {
  visibility: hidden !important;
}
.daterangepicker {
  left: 80% !important;
}
.range {
  padding-left: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.status {
  position: relative;
  display: inline-block;
  width: 320px;
}
.range .mx-datepicker-range {
  width: 210px !important;
}
/*! rtl:end:ignore */
</style>
